(function(){
  var KEY='dbWishlist';var WLPAGE='/pages/wunschliste';
  function read(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return[]}}
  function write(a){try{localStorage.setItem(KEY,JSON.stringify(a))}catch(e){}}
  function has(id){return read().some(function(x){return String(x.id)===String(id)})}
  function toggle(item){var a=read();var i=-1;a.forEach(function(x,ix){if(String(x.id)===String(item.id))i=ix});if(i>-1){a.splice(i,1);write(a);return false}a.unshift(item);write(a);return true}
  function count(){return read().length}
  function esc(t){return (t||'').split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;')}
  var HEART=`<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/></svg>`;
  function injectCSS(){
    if(document.getElementById('wl-css'))return;
    var s=document.createElement('style');s.id='wl-css';
    s.textContent=`.wishlist-btn{--wl:#e0245e;background:rgba(255,255,255,.92);border:1px solid rgba(0,0,0,.08);border-radius:50%;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;color:#333;transition:transform .15s,color .15s} .wishlist-btn:hover{transform:scale(1.08)} .wishlist-btn svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.8} .wishlist-btn.is-active{color:var(--wl)} .wishlist-btn.is-active svg{fill:var(--wl);stroke:var(--wl)} .product-item__media-wrapper{overflow:visible} .wl-card-btn{position:absolute;top:10px;right:10px;z-index:4} .wishlist-count{display:inline-flex;min-width:16px;height:16px;padding:0 4px;border-radius:999px;background:var(--wl,#e0245e);color:#fff;font-size:10px;font-weight:700;line-height:16px;align-items:center;justify-content:center} .wishlist-count[hidden]{display:none} .wl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:20px;margin:24px 0} .wl-item{position:relative;border:1px solid rgba(0,0,0,.08);border-radius:10px;overflow:hidden;background:#fff} .wl-item .wl-img{display:block;aspect-ratio:1;background:#f6f6f6} .wl-item .wl-img img{width:100%;height:100%;object-fit:cover;display:block} .wl-info{padding:12px 14px} .wl-t{font-size:14px;font-weight:600;margin:0 0 4px;line-height:1.3} .wl-t a{color:inherit;text-decoration:none} .wl-p{font-size:14px;color:#555} .wl-rm{position:absolute;top:8px;right:8px;background:rgba(255,255,255,.95);border:1px solid rgba(0,0,0,.1);border-radius:50%;width:30px;height:30px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:18px;line-height:1;color:#333} .wl-empty{text-align:center;color:#777;padding:48px 16px;font-size:15px} .social-icons li{zoom:1.2} .wl-disc{display:flex;gap:8px;margin:0 0 14px}.wl-disc input{flex:1;min-width:0;border:1px solid rgba(0,0,0,.18);border-radius:0;padding:11px 12px;font-size:14px;background:#fff;color:#222}.wl-disc button{border:0;border-radius:0;background:#121212;color:#fff;padding:0 18px;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap}.wl-disc button:hover{opacity:.9}`;
    document.head.appendChild(s);
  }
  function injectCardButtons(){
    document.querySelectorAll('.product-item[data-id]').forEach(function(card){
      if(card.querySelector('.wishlist-btn'))return;
      var media=card.querySelector('.product-item__media-wrapper')||card.querySelector('.product-item__media')||card;
      if(media&&getComputedStyle(media).position==='static')media.style.position='relative';
      var img=card.querySelector('.product-item__image img')||card.querySelector('img');
      var priceEl=card.querySelector('.product-item__price');
      var b=document.createElement('button');
      b.type='button';b.className='wishlist-btn wl-card-btn';b.setAttribute('aria-label','Auf die Wunschliste');
      b.setAttribute('data-wl-id',card.getAttribute('data-id')||'');
      b.setAttribute('data-wl-title',card.getAttribute('data-title')||'');
      b.setAttribute('data-wl-url',card.getAttribute('data-url')||'#');
      b.setAttribute('data-wl-image',img?(img.currentSrc||img.src||''):'');
      b.setAttribute('data-wl-price',priceEl?priceEl.textContent.trim():'');
      (media||card).appendChild(b);
    });
  }
  function makeWlLink(){
    var a=document.createElement('a');a.className='wl-header';a.href=WLPAGE;a.setAttribute('aria-label','Wunschliste');
    a.innerHTML=HEART+`<span class='wishlist-count' hidden>0</span>`;
    a.style.cssText='position:relative;display:inline-flex;align-items:center;justify-content:center;color:inherit;padding:6px;margin:0 2px';
    var svg=a.querySelector('svg');if(svg){svg.style.width='22px';svg.style.height='22px';svg.style.fill='none';svg.style.stroke='currentColor';svg.style.strokeWidth='1.7'}
    var cnt=a.querySelector('.wishlist-count');if(cnt)cnt.style.cssText='position:absolute;top:0;right:0';
    return a;
  }
  function injectHeader(){
    // Desktop: Herz neben Warenkorb. Mobil: Herz rechts neben Burger (links im Header), Account nur als Symbol neben Warenkorb.
    var carts=document.querySelectorAll('a.header__cart-link');
    var acctSrc=document.querySelector('.header__icon-touch--account')||document.querySelector('a[data-account-link]');
    carts.forEach(function(cart){
      if(!cart||!cart.parentNode)return;
      var isMobile=!!(cart.closest&&cart.closest('.header__content-mobile'));
      if(isMobile){
        if(acctSrc&&!cart.parentNode.querySelector('.wl-mobile-account')){
          var ac=acctSrc.cloneNode(true);
          ac.classList.add('wl-mobile-account');
          ac.removeAttribute('data-account-quick-view');
          ac.removeAttribute('data-account-link');
          var lbl=ac.querySelector('.header__icon-with-label-touch-label');if(lbl)lbl.remove();
          cart.parentNode.insertBefore(ac,cart);
        }
      }else{
        var prev=cart.previousElementSibling;
        if(!(prev&&prev.classList&&prev.classList.contains('wl-header')))cart.parentNode.insertBefore(makeWlLink(),cart);
      }
    });
    document.querySelectorAll('.header__content-mobile [data-menu-button]').forEach(function(burger){
      if(!burger||!burger.parentNode)return;
      if(burger.parentNode.querySelector('.wl-mobile-heart'))return;
      var a=makeWlLink();a.classList.add('wl-mobile-heart');
      if(burger.nextSibling)burger.parentNode.insertBefore(a,burger.nextSibling);else burger.parentNode.appendChild(a);
    });
  }
  function markButtons(){
    document.querySelectorAll('.wishlist-btn').forEach(function(btn){
      if(!btn.querySelector('svg'))btn.innerHTML=HEART;
      var id=btn.getAttribute('data-wl-id');var active=has(id);
      btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',active?'true':'false');
      if(btn.dataset.wlInit)return;btn.dataset.wlInit='1';
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        var item={id:id,handle:btn.getAttribute('data-wl-handle'),title:btn.getAttribute('data-wl-title'),url:btn.getAttribute('data-wl-url'),image:btn.getAttribute('data-wl-image'),price:btn.getAttribute('data-wl-price')};
        var added=toggle(item);
        btn.classList.toggle('is-active',added);btn.setAttribute('aria-pressed',added?'true':'false');
        updateCount();renderPage();
      });
    });
  }
  function updateCount(){var c=count();document.querySelectorAll('.wishlist-count').forEach(function(el){el.textContent=c;if(c>0)el.removeAttribute('hidden');else el.setAttribute('hidden','')})}
  function renderPage(){
    var box=document.getElementById('wishlist-items');if(!box)return;
    var a=read();
    if(!a.length){box.innerHTML=`<div class='wl-empty'>Deine Wunschliste ist noch leer. Tippe auf das Herz bei einem Produkt, um es hier zu speichern.</div>`;return}
    var h=`<div class='wl-grid'>`;
    a.forEach(function(x){
      h+=`<div class='wl-item'><button class='wl-rm' aria-label='Entfernen' data-rm='`+x.id+`'>&times;</button><a class='wl-img' href='`+(x.url||'#')+`'>`+(x.image?`<img src='`+x.image+`' alt='`+esc(x.title)+`'>`:``)+`</a><div class='wl-info'><p class='wl-t'><a href='`+(x.url||'#')+`'>`+esc(x.title)+`</a></p><div class='wl-p'>`+(x.price||``)+`</div></div></div>`;
    });
    h+=`</div>`;box.innerHTML=h;
    box.querySelectorAll('[data-rm]').forEach(function(b){b.addEventListener('click',function(){toggle({id:b.getAttribute('data-rm')});markButtons();updateCount();renderPage()})});
  }
  function injectDiscount(){
    // Gutscheincode-Feld direkt ÜBER dem Checkout-Button, ohne Rundung. Warenkorb-Seite + Mini-Warenkorb.
    var spots=[['.cart__footer-inner','.cart__input-buttons'],['.quick-cart__footer','.quick-cart__submit']];
    spots.forEach(function(pair){
      document.querySelectorAll(pair[0]).forEach(function(box){
        var before=box.querySelector(pair[1]);
        if(!before)return;
        var ex=box.querySelector('.wl-disc');
        if(ex){ if(ex.nextElementSibling===before)return; ex.parentNode.removeChild(ex); }
        var f=document.createElement('div');f.className='wl-disc';
        f.innerHTML="<input type='text' placeholder='Gutscheincode' aria-label='Gutscheincode' autocomplete='off'><button type='button'>Einlösen</button>";
        var inp=f.querySelector('input'),btn=f.querySelector('button');
        function go(){var c=(inp.value||'').trim();if(c){location.href='/discount/'+encodeURIComponent(c)+'?redirect=/cart';}}
        btn.addEventListener('click',go);
        inp.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();go();}});
        box.insertBefore(f,before);
      });
    });
  }
  function openCartDrawer(){
    var ts=document.querySelectorAll('[data-header-cart]');
    var t=null;ts.forEach(function(x){if(!t&&x.offsetParent!==null)t=x;});
    t=t||ts[0];
    if(t)t.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true}));
  }
  function hookAddToCart(){
    if(window.__dbCartHook)return;window.__dbCartHook=1;
    function isAdd(u){return typeof u==='string'&&u.indexOf('/cart/add')>-1;}
    if(window.fetch){
      var of=window.fetch;
      window.fetch=function(){
        var a=arguments;var u='';try{u=(a[0]&&a[0].url)?a[0].url:String(a[0]||'');}catch(e){}
        var pr=of.apply(this,a);
        try{ if(isAdd(u)){ pr.then(function(r){ setTimeout(openCartDrawer,140); }).catch(function(){}); } }catch(e){}
        return pr;
      };
    }
    try{
      var oo=XMLHttpRequest.prototype.open,os=XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open=function(m,u){this.__dbU=u;return oo.apply(this,arguments);};
      XMLHttpRequest.prototype.send=function(){
        var self=this;
        if(isAdd(String(self.__dbU||''))){self.addEventListener('load',function(){if(self.status>=200&&self.status<300)setTimeout(openCartDrawer,140);});}
        return os.apply(this,arguments);
      };
    }catch(e){}
  }
  function init(){injectCSS();injectHeader();injectCardButtons();markButtons();updateCount();renderPage();injectDiscount();hookAddToCart()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  var t;try{var mo=new MutationObserver(function(){clearTimeout(t);t=setTimeout(function(){injectCardButtons();markButtons();updateCount();injectDiscount()},150)});mo.observe(document.body,{childList:true,subtree:true})}catch(e){}
  window.DBWishlist={refresh:init,count:count};
})();
